import type { Optional } from '@festina-life/core'
import type { editor, IPosition, Uri } from 'monaco-editor'

import type { FoldingResult } from './contracts/FoldingResult'
import type { FormatResult } from './contracts/FormatResult'
import type { HoverResult } from './contracts/HoverResult'
import type { SignatureHelpResult } from './contracts/SignatureHelpResult'
import type { SuggestionResult } from './contracts/SuggestionResult'
import type { ValidationResult } from './contracts/ValidationResult'

export type LanguageWorker<T> = {
  hover: (input: T) => Promise<Optional<HoverResult>>
  suggestion: (input: T) => Promise<SuggestionResult>
  signatureHelp: (input: T) => Promise<SignatureHelpResult>
  validation: (input: T) => Promise<ValidationResult>
  findFoldings: (input: T) => Promise<FoldingResult>
  format: (input: T, formatWidth?: number) => Promise<FormatResult>
}

export type LanguageWorkerAccessor<T> = (
  ...uri: Uri[]
) => Promise<null | LanguageWorker<T>>

export type ProviderMappingInput = {
  model: editor.ITextModel
  position?: IPosition
}
export type WorkerMapping<T> = (
  data: ProviderMappingInput,
) => Promise<Optional<WorkerMappingResult<T>>>

export type WorkerMappingResult<T> = {
  textTransformer: FPlusTextMapper
  data: Optional<T>
}

export type FPlusTextMapper = (text: Optional<string>) => Optional<string>

export const nullSafeTextMapper = (
  result: WorkerMappingResult<unknown>,
): FPlusTextMapper => result?.textTransformer ?? ((t) => t)
